module.exports = __webpack_public_path__ + "img/wheel-of-fotrune-bg.4e37a092.jpg";